import React from "react";
import "./Blue_btn.css";
import { Button } from "react-bootstrap";

function Blue_btn({ btn_text, type = "button", onClick, ...rest }) {
  return (
    <section className="Blue_btn_holder">
      <Button className="blue_btn" type={type} onClick={onClick} {...rest}>
        {btn_text}
      </Button>
    </section>
  );
}

export default Blue_btn;
